import { render, staticRenderFns } from "./NameScreening.vue?vue&type=template&id=410a43a2&"
import script from "./NameScreening.vue?vue&type=script&lang=js&"
export * from "./NameScreening.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports